module.exports = __webpack_public_path__ + "static/media/playstore.aa97a9e2.jpg";